import type { ElementType } from "react";
import {
  DEFAULT_ELEMENT,
  HEADING_VARIANTS,
  type TypographyBaseProps,
  type TypographyVariant,
} from "./types";
import { buildTypographyClasses } from "./utils";

type HeadingVariant = Extract<TypographyVariant, "h1" | "h2" | "h3">;

export interface HeadingProps extends Omit<TypographyBaseProps, "variant"> {
  variant: HeadingVariant;
}

export function Heading({
  variant,
  tone,
  as,
  className,
  children,
  dir,
  lang,
  "data-testid": dataTestId,
  ...rest
}: HeadingProps) {
  if (!HEADING_VARIANTS.has(variant)) {
    throw new Error(
      `<Heading> received non-heading variant "${variant}". Use <Text> instead.`,
    );
  }

  const Component: ElementType = as ?? DEFAULT_ELEMENT[variant];
  const classes = buildTypographyClasses({ variant, tone, className });

  return (
    <Component
      className={classes}
      dir={dir}
      lang={lang}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </Component>
  );
}
